import { z } from 'zod';
import { StatusTypeSchema } from '../enums/status.js';
import { promptDetailsSchema, promptListItemSchema, promptMessageSchema } from '../types/prompts.js';

export const getPromptsResponseSchema = z.object({
  items: z.array(promptListItemSchema),
});

export const createPromptRequestBodySchema = z.object({
  name: z.string().min(1),
  description: z.string().default(''),
  messages: z.array(promptMessageSchema).default([]),
  inputSchema: z.record(z.string(), z.unknown()).default({}),
});

export const createPromptResponseSchema = z.object({
  id: z.number(),
  identifier: z.string().uuid(),
});

export const getPromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});

export const getPromptResponseSchema = promptDetailsSchema;

export const updatePromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});

export const updatePromptRequestBodySchema = z.object({
  name: z.string().min(1),
  description: z.string(),
  status: StatusTypeSchema,
  messages: z.array(promptMessageSchema),
  inputSchema: z.record(z.string(), z.unknown()),
});

export const deletePromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});
